import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { GroupSetDevelopmentGoalModule } from '@main-client/src/app/group-set-development-goal/group-set-development-goal.module';

import { GroupAccountGoalsComponent } from './group-account-goals.component';

@NgModule({
  declarations: [GroupAccountGoalsComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    GroupSetDevelopmentGoalModule,
    MatButtonModule,
    MatIconModule,
  ],
  exports: [GroupAccountGoalsComponent],
})
export class GroupAccountGoalsModule {}
